module.exports = __webpack_public_path__ + "f714369f1bf6d3ac1de31f78e278cc44.svg";